import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY, Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { catchError, mergeMap, tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  @ViewChild('errorContainer') errorContainer: ElementRef;
  errorType = this.activatedRoute.snapshot.queryParamMap.get('errorType');
  hasError = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.loadTemplate().pipe(untilDestroyed(this)).subscribe();
  }

  private loadTemplate(): Observable<string> {
    if (!this.errorType) {
      this.hasError = true;
      return EMPTY;
    }

    return fromFetch(`/assets/error-pages/${this.errorType}.html`).pipe(
      mergeMap((res) => {
        if (!res.ok) {
          throw new Error();
        }

        return res.text();
      }),
      tap((data) => {
        this.processTemplate(data);
      }),
      catchError(() => {
        this.hasError = true;
        return EMPTY;
      })
    );
  }

  private processTemplate(data: string): void {
    const div = this.renderer.createElement('div');
    this.renderer.setProperty(div, 'innerHTML', data);
    this.renderer.appendChild(this.errorContainer.nativeElement, div);
  }
}
